module.exports = __webpack_public_path__ + "img/Group 1.f002b100.png";